import { AUTH_SUCCESS, AUTH_FAILED, RESET_PROJECT_INFO, SET_PROJECT_INFO, REFRESH_PROJECT_INFO,VULNERABLE_ONLY,TOGGLE_LANGUAGE,
    COLLAPSE_ALL, COLLAPSE_LICENSING, COLLAPSE_STABILITY,COLLAPSE_SECURITY, COLLAPSE_HISTORY, UPDATE_BADGES, SET_HISTORY_DATA, 
    SET_HISTORY_RAW, ADD_HISTORY_REPORT, STORE_HISTORY_SELECTION, SET_REPORT_READY, SET_RECOMPUTE_REMINDER, TOGGLE_ACCOUNT_INFO,
    SET_REPORT_LICENSING
} from '../constants/constants.js'


const initialUserState={
    user: null,
    auth: null
}

export const setUser = (state=initialUserState,action={})=>{
    if(action.type===AUTH_SUCCESS){
        return{
            auth:true,
            user: action.payload
        }
    }
    if(action.type===AUTH_FAILED){
        return {
            user: null,
            auth: false
        }
    }
    return state
}



const initialReportState={
    projectInfo:{},
    report:{},
    history:[],
    summary:{},
    exclusions:{},
    reportOriginal:{},
    reportReady:false,
    errorProject:false,
    errorReport:false,
    urlParams:{},
    titleState:{},
    badges: {},
    isExperimental: false,
    isLatestReport: true
}

export const projectInfo = (state=initialReportState, action={})=>{
    if(action.type===RESET_PROJECT_INFO){
        // state.report=  {}
        // state.reportReady = false
        return {
            ...state,
            report: {},
            reportReady: false
        }
    }
    
    if(action.type===SET_PROJECT_INFO)
        return {
            ...state,
            ...action.payload
        }

    if(action.type===SET_REPORT_READY){
        
        return{
            ...state,
            reportReady: true
        }
    }

    if(action.type===REFRESH_PROJECT_INFO){
        return {
            ...state,
            ...action.payload
        }
    }
    if(action.type===UPDATE_BADGES && action.payload){
        
        return { ...state,
            badges: action.payload
        }
    }

    if(action.type===TOGGLE_ACCOUNT_INFO){
        return {
            ...state,
            showAccountInfo: !state.showAccountInfo
        }
    }

    if (action.type===SET_REPORT_LICENSING){
        return {
            ...state,
            report:{
                ...state.report,
                licensing: action.payload
            }
        }
    }
        
    return state
    
}

const initialLanguageFilterState = {
    vulnerableOnly: true,
    toggledLanguages: []
}

export const languagesFilter = (state=initialLanguageFilterState,action={}) =>{
    if(action.type===VULNERABLE_ONLY){
        return{
            ...state,
            vulnerableOnly: !state.vulnerableOnly
        }
    }

    if(action.type===TOGGLE_LANGUAGE){
        return{
            ...state,
            toggledLanguages: action.payload
        }
    }

    return state;
}


const initialSectionsState = {
    executive: false,
    security: false,
    stability: false,
    licensing: false,
    history: true
}


export const summariesState = (state = initialSectionsState, action = {}) => {

    if (action.type===COLLAPSE_ALL){
        return  { ...state,
            ...action.payload
        }
    }
    if (action.type===COLLAPSE_SECURITY){
        return {
            ...state,
            security: action.payload

        }
    }    
    if (action.type===COLLAPSE_STABILITY){
        return {
            ...state,
            stability: action.payload

        }
    }
    if (action.type===COLLAPSE_LICENSING){
        return {
            ...state,
            licensing: action.payload

        }
    }
    if (action.type===COLLAPSE_HISTORY){
        return {
            ...state,
            history: action.payload

        }
    }

    return state
}


const initialHistoryDataState = {
    history: null,
    historyReports: null,
    selectedOption: 0,

}

export const historyData = (state = initialHistoryDataState, action = {}) => {
    if ( action.type === SET_HISTORY_DATA ){
        return {...state, ...action.payload}
    } 
    if ( action.type === SET_HISTORY_RAW ){
        return {...state, history: action.payload}
    }
    if ( action.type === ADD_HISTORY_REPORT){
        if(!state.historyReports){
            return {...state, historyReports: [action.payload]}
        }
        else{
            return { ...state, historyReports: [...state.historyReports, action.payload]}
        }
    }
    if( action.type === STORE_HISTORY_SELECTION){
        return {...state, selectedOption: action.payload}
    }
    return state
}


const initialRecomputeReminderState = {
    shouldRecompute: false
}

export const recomputeReminderState = (state = initialRecomputeReminderState, action = {} ) =>{
    if (action.type === SET_RECOMPUTE_REMINDER) {
        if (action.payload){
            return {
                shouldRecompute: false
            }
        }
        return {
            shouldRecompute: true
        }
    }
    return state
}